import { Box, MenuItem, TextField, Tooltip, Typography } from '@mui/material'
import { WidgetProps } from '@rjsf/utils'
import { useTranslation } from 'react-i18next'
import { dashify } from 'utils/dashify'

export const SelectWidget = (props: WidgetProps) => {
  const { t } = useTranslation()
  const {
    rawErrors,
    uiSchema,
    readonly,
    autofocus,
    formContext,
    hideLabel,
    hideError,
    ...others
  } = props

  const label = uiSchema
    ? t(
        `ws-step-form-${dashify(
          uiSchema['ui:label-translation-key'] ||
            uiSchema['ui:label'] ||
            uiSchema['ui:title'],
        )}`,
        {
          defaultValue:
            uiSchema['ui:label'] ||
            uiSchema['ui:title'] ||
            uiSchema['ui:label-translation-key'],
          ns: 'project',
        },
      )
    : null

  const notInitialzedOrEmpty = !props.value || props.value === 'NotInitialized'
  let errors = rawErrors?.join(' ') ?? ''

  if (props.required && notInitialzedOrEmpty) {
    if (!errors) {
      errors = t('validation-required-field', { ns: 'common' })
    }
  }

  return (
    <Box className={'select-widget'}>
      <Tooltip
        title={notInitialzedOrEmpty ? '' : t(props.value, { ns: 'project' })}
        placement="top"
      >
        <TextField
          {...others}
          value={notInitialzedOrEmpty ? '' : props.value}
          slotProps={{
            htmlInput: {
              sx: {
                fontSize: '12px',
                padding: '2px 0 2px 0',
              },
            },
            input: {
              readOnly: readonly,
              sx: {
                fontSize: '12px',
                padding: '1px 0em 0px 0',
              },
            },
          }}
          size="small"
          select
          label={label}
          variant="standard"
          fullWidth
          onChange={(e) => {
            props.onChange(e.target.value)
          }}
          // sx={{
          //   '& .MuiSelect-select': {
          //     paddingBottom: 0,
          //   },
          //   '& .MuiInputBase-root': {
          //     marginTop: '15px',
          //   },
          // }}
          onBlur={(e) => props.onBlur(props.id, e.target.value)}
          onFocus={(e) => props.onFocus(props.id, e.target.value)}
          color="primary"
          error={
            Boolean(props.rawErrors?.length) ||
            (notInitialzedOrEmpty && props.required)
          }
          helperText={errors}
          required={props.required}
        >
          {props.schema['x-enumNames']?.map((name: string | undefined) => {
            if (!name || name === 'NotInitialized') return null
            return (
              <MenuItem key={name} value={name}>
                <Typography variant="body2" noWrap>
                  {t(name, { defaultValue: name, ns: 'project' })}
                </Typography>
              </MenuItem>
            )
          })}
        </TextField>
      </Tooltip>
      {/* <JsonViewer data={props} /> */}
    </Box>
  )
}
